import { MixedSection } from "components/domain/contents/sections/MixedSection";
import { Mix_Content_Tag_Enum_Enum } from "graphql/generated";
import { LIMIT, buildQueryVariables } from "utils/buildQueryVariables";

interface DesktopLayoutProps {
    tags: Mix_Content_Tag_Enum_Enum[] | null;
}

/**
 * Desktop 레이아웃 (≥ 1025px)
 *
 * 표시 규칙:
 * - MixedSection만 표시 (OriginalSection, RecentSection 대체)
 * - tags 필터링은 동일하게 적용
 */
export const DesktopLayout = ({ tags }: DesktopLayoutProps) => {
    return (
        <div
            className="mb-0 hidden md:mb-[var(--section-tablet-gap)]
                lg:mb-[var(--section-desktop-gap)] lg:block"
        >
            <MixedSection
                data-observer-id="mixed"
                contentSection="mixed"
                variables={buildQueryVariables("recent", tags, LIMIT.default)}
            />
        </div>
    );
};
